import { type TimeRangeKey } from '../../shared/insights/utils/insightsTransforms'

export type RangeKey = '90d' | '6m' | '12m'

export const RANGE_TO_TIME_RANGE: Record<RangeKey, TimeRangeKey> = {
  '90d': '3M',
  '6m': '6M',
  '12m': '1Y',
}

export const RANGE_OPTIONS = [
  { key: '90d', label: '90D' },
  { key: '6m', label: '6M' },
  { key: '12m', label: '12M' },
]

export const RANGE_PERIOD: Record<RangeKey, string> = {
  '90d': '90 days',
  '6m': '6 months',
  '12m': '12 months',
}

export const RANGE_PERIOD_TEXT: Record<RangeKey, string> = {
  '90d': `last ${RANGE_PERIOD['90d']}`,
  '6m': `last ${RANGE_PERIOD['6m']}`,
  '12m': `last ${RANGE_PERIOD['12m']}`,
}

export const RANGE_TO_USER_SCORE_LIST_CHART: Record<RangeKey, string> = {
  '90d': 'user_score_list_3_months',
  '6m': 'user_score_list_6_months',
  '12m': 'user_score_list_12_months',
}

export const RANGE_TO_USER_SCORE_RESULT_LIST_CHART: Record<RangeKey, string> = {
  '90d': 'user_score_result_list_3_months',
  '6m': 'user_score_result_list_6_months',
  '12m': 'user_score_result_list_12_months',
}
